import { SubProductPost } from "./subProductPost";

export class LoanStep4 {

    // applicable: boolean = false;
    // indQuotSubprodMapEntityId?: {
    //     portfolioId: number,
    //     quotationId: string,
    //     subproductId: string
    // };
    // amount: number = 0;
    // indRecoveryModeEntityIdDto?: {
    //     portfolioId: number,
    //     recoveryMode: string
    // };
    // tenure: number;

    statusId: string = "";
    custId: string;
    listOfSubProducts: SubProductPost[];
    subProdFlag: number = 0;
    financedAmount: number = 0;
    newQuotFlag : number; // flag to idnetify the type of car selected
    newVehBrandId : string; // selected bank name
    emi:number;
    interestrate:number;
    
    indQuotLoanAssetId: {
        portfolioId: number;
        quotationId: string;
    }
    indusRefId: string = "";

    constructor() {
        this.listOfSubProducts = [];
        // this.indQuotSubprodMapEntityId = {
        //     portfolioId: 0,
        //     quotationId: "",
        //     subproductId: ""
        // }
        // this.indRecoveryModeEntityIdDto = {
        //     portfolioId: 0,
        //     recoveryMode: ""
        // }
        this.indQuotLoanAssetId = {
            portfolioId: 0,
            quotationId: ""
        }
    }

}